import React from 'react';
import { Offcanvas, Button, Form } from 'react-bootstrap';
import { X } from 'react-bootstrap-icons';
import { FaFileExcel } from 'react-icons/fa';
import DateFilter from '../../../../Caja/Receipts/components/Filters/DateFilter';
import './ReviewsOffCanvas.scss';

type ReviewsSection = 'general' | 'usuarios' | 'listado';

interface ReviewsOffCanvasProps {
  show: boolean;
  onHide: () => void;
  section: ReviewsSection;
  startDate: string;
  endDate: string;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  soloSesionActual: boolean;
  onSoloSesionActualChange: (checked: boolean) => void;
  onExportToExcel?: () => void;
}

const ReviewsOffCanvas: React.FC<ReviewsOffCanvasProps> = ({
  show,
  onHide,
  section,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  soloSesionActual,
  onSoloSesionActualChange,
  onExportToExcel,
}) => {
  
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      className="mp-offcanvas reviews-offcanvas"
      backdrop={true}
      scroll={false}
    >
      <Offcanvas.Header className="offcanvas-header">
        <div className="header-content">
          <Offcanvas.Title className="offcanvas-title">
            Opciones de Filtrado
          </Offcanvas.Title>
          <div className="section-indicator">
            Reviews
          </div>
        </div>
        <Button
          variant="none"
          className="close-button"
          onClick={onHide}
          aria-label="Cerrar filtros"
        >
          <X size={24} />
        </Button>
      </Offcanvas.Header>

      <Offcanvas.Body className="offcanvas-body">
        <div className="filters-container">
          <div className="filter-section">
            <h6 className="filter-section-title">Filtros Generales</h6>

            <div className="filter-group">
              <Form.Label className="filter-label">Rango de fechas</Form.Label>
              <div className="receipt-date-filter-container">
                <DateFilter
                  startDate={startDate}
                  setStartDate={onStartDateChange}
                  endDate={endDate}
                  setEndDate={onEndDateChange}
                />
              </div>
            </div>

            <div className="filter-group">
              <div className="checkbox-filter">
                <input
                  type="checkbox"
                  id="soloSesionActualMobile"
                  checked={soloSesionActual}
                  onChange={e => onSoloSesionActualChange(e.target.checked)}
                />
                <label htmlFor="soloSesionActualMobile">Solo sesión actual</label>
              </div>
            </div>

            {onExportToExcel && (
              <div className="filter-group">
                <Button
                  variant="none"
                  className="excel-export-button"
                  onClick={onExportToExcel}
                >
                  <FaFileExcel />
                  <span>Exportar a Excel</span>
                </Button>
              </div>
            )}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ReviewsOffCanvas;